var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"un-complete"},[_c('infos',{ref:"infos",attrs:{"infoData":_vm.infoData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }